import { ReactNode } from "react";
import classes from "./ContentLayout.module.css";

const ContentLayout = ({ children }: { children: ReactNode }) => {
  return <div className={classes.root}>{children}</div>;
};

export default ContentLayout;
